import React, { useEffect } from 'react';
import Table from '../../../modules/components/Table'
import Grid from '@material-ui/core/Grid';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import AddEditRedeems from './AddEditRedeems';
import firebase from "firebase";

export default function Index(props) {

    const [headCells, setHeadCells] = React.useState([]);
    const [headMobileCells, setHeadMobileCells] = React.useState([]);
    const [searchValue, setSearchValue] = React.useState("");
    const [searchCell, setSearchCell] = React.useState([]);
    const [displayInfo, setDisplayInfo] = React.useState([]);
    const [editCells, setEditCells] = React.useState([]);
    const [addCells, setAddCells] = React.useState([]);
    const [addCellsName, setAddCellsName] = React.useState([]);
    const matches = useMediaQuery(theme => theme.breakpoints.up('sm'));

    useEffect(() => {

        setHeadCells([
            { id: 'uuid', label: 'Tracking Number' },
            { id: 'first_name_orders', label: 'First Name' },
            { id: 'last_name_orders', label: 'Last Name' },
            { id: 'proof_of_payment', label: 'Proof of Payment' },
            { id: 'amount', label: 'Amount' },
            { id: 'paid_total', label: 'Total Paid' },
            { id: 'created', label: 'Order Date' },
            { id: 'status_orders', label: 'Status' }
        ])

        setHeadMobileCells([
            { id: 'uuid', label: 'Tracking Number' },
        ])
    
        setSearchCell([
            { id: 'uuid', label: 'Tracking Number' },
        ])

        setDisplayInfo([
            { id: 'id', label: 'ID' },
            { id: 'uuid', label: 'Tracking Number' },
            { id: 'created', label: 'Order Date' },
            { id: 'status_orders', label: 'Status' },
            { id: 'user_id', label: 'User ID' },
            { id: 'user_name', label: 'User Name' },
            { id: 'user_phone', label: 'User Phone' },
            { id: 'shipping_address', label: 'Shipping Address' },
            { id: 'billing_address', label: 'Billing Address' },
            { id: 'amount', label: 'Amount' },
        ])

        setEditCells([
            { id: 'status_orders', label: 'Status' },
            { id: 'paid_total', label: 'Total Paid' },
        ])

        setAddCells([
            { id: 'uuid', label: 'Tracking Number' },
            { id: 'status_orders', label: 'Status' },
            { id: 'customer', label: 'Customer' },
            { id: 'products', label: 'Products' },
            { id: 'amount', label: 'Amount' },
            { id: 'paid_total', label: 'Total Paid' },
        ])

        setAddCellsName({ 
            created: firebase.database.ServerValue.TIMESTAMP,
            updated: firebase.database.ServerValue.TIMESTAMP,
            status_orders: '',
            orders: {},
            status_orders_serial: 1,
            shipping_address: {},
            billing_address: {},
            payment_gateway: 'cod',
            customer: {},
            products: [],
            amount: '',
            paid_total: '',
            delivery_fee: '',
            handle_by_orders: null
         })
    
        setSearchValue("uuid")
        
    }, []);

    return (
    <Grid>
        <Table 
            {...props}
            customizeDialog={AddEditRedeems}
            control={true}
            orderBy="created" 
            data="gift_redeem" 
            addItemButton={false}
            addItemText="Add Redeems"
            addItemIcon={<AddCircleIcon/>}
            addCells={addCells}
            addCellsName={addCellsName}
            folder_data="gift_redeem_zone"
            displayInfo={displayInfo}
            editCells={editCells}
            matches={matches}
            headCells={matches ? headCells : headMobileCells} 
            searchValue={searchValue} 
            searchCell={searchCell}/>
    </Grid>
    )

}
  